/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnerscolumnpaid2Inputs */

const en_partnerscolumnpaid2 = /** @type {(inputs: Partnerscolumnpaid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paid plans`)
};

const de_partnerscolumnpaid2 = /** @type {(inputs: Partnerscolumnpaid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezahlte Tarife`)
};

/**
* | output |
* | --- |
* | "Paid plans" |
*
* @param {Partnerscolumnpaid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnerscolumnpaid2 = /** @type {((inputs?: Partnerscolumnpaid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnerscolumnpaid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnerscolumnpaid2(inputs)
	return de_partnerscolumnpaid2(inputs)
});
export { partnerscolumnpaid2 as "partnersColumnPaid" }